import CopyButton from "@components/buttons/CopyButton";
import React from "react";

interface LabelRowProps {
  label: string;
  value?: string;
  isCopy?: boolean;
  valueComp?: React.ReactNode;
  alignment?: "row" | "col";
}
const LabelRow: React.FC<LabelRowProps> = ({
  label,
  value,
  isCopy = false,
  valueComp,
  alignment = "row",
}) => {
  const isColumnLayout = alignment === "col";

  return (
    <div
      className={`flex ${
        isColumnLayout ? "flex-col gap-[4px]" : "flex-row justify-between"
      } items-${isColumnLayout ? "start" : "center"}`}
    >
      <div
        className={`flex ${
          isColumnLayout ? "w-full flex-row justify-between" : ""
        }`}
      >
        <span className="text-text-base text-[12px] font-normal">{label}</span>
        {isColumnLayout && isCopy && value && (
          <CopyButton
            copyText={value || ""}
            copyMessage={`${label} copied to clipboard`}
          />
        )}
      </div>
      {valueComp ? (
        valueComp
      ) : (
        <div className="flex flex-row items-center gap-[4px]">
          <span className="font-normal text-[12px] text-text-base truncate p-0 m-0">
            {value && value?.length > 0 ? value : "- -"}
          </span>
          {isCopy && !isColumnLayout && (
            <CopyButton
              copyText={value || ""}
              copyMessage={`${label} copied to clipboard`}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default LabelRow;
